const dateOptions = {
  month: '2-digit' as '2-digit',
  day: '2-digit' as '2-digit',
  year: 'numeric' as 'numeric'
};


const datetimeOptions = {
  month: '2-digit' as '2-digit',
  day: '2-digit' as '2-digit',
  year: 'numeric' as 'numeric',
  hour: 'numeric' as 'numeric',
  minute: 'numeric' as 'numeric'
};


export const toUSDate = (value?: string) => {
  if (!value) return;
  return new Date(value).toLocaleDateString('en-US', dateOptions).replace(/\//g, '-');
};

export const toUSDatetime = (value?: string) => {
  if (!value) return;
  return new Date(value).toLocaleDateString('en-US', datetimeOptions);
};

export function getInitials(name: string) {
  return name
    .replace(/\./g, ' ')
    .trim()
    .split(/\s+/)
    .filter(word => word.length > 0)
    .slice(0, 2)
    .map(word => word.charAt(0).toUpperCase())
    .join('');
}

export function toTitleCase(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}